<div
  class="py-3 px-4 rounded-md border border-solid"
  [ngClass]="{
    'bg-accent-600/10 border-accent-600': announcement.type === 'information',
    'bg-red-600/10 border-red-600': announcement.type === 'error'
  }"
  [innerHTML]="announcement.content"
></div>
